import React from 'react';
import { Nav, Footer, DisclaimerBar } from '../components/Chrome';
import { useI18n } from '../i18n';

export default function Methodology() {
  const { t } = useI18n();
  const steps = [
    { title: t('meth.s1.title'), body: t('meth.s1.body') },
    { title: t('meth.s2.title'), body: t('meth.s2.body') },
    { title: t('meth.s3.title'), body: t('meth.s3.body') },
    { title: t('meth.s4.title'), body: t('meth.s4.body') },
    { title: t('meth.s5.title'), body: t('meth.s5.body') },
    { title: t('meth.s6.title'), body: t('meth.s6.body') },
  ];
  return (
    <div>
      <Nav />
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 py-16">
        <div className="mono text-[10px] uppercase tracking-widest2 text-gold mb-4">METHODOLOGY</div>
        <h1 className="serif text-5xl md:text-6xl leading-tight max-w-3xl">{t('meth.title')}</h1>
        <p className="mt-4 text-white/60 max-w-2xl">{t('meth.sub')}</p>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-4">
          {steps.map((s, i) => (
            <div key={i} className="border hairline bg-surface1 p-8">
              <div className="serif text-2xl text-gold">{s.title}</div>
              <p className="mt-4 text-white/70 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
      <DisclaimerBar />
      <Footer />
    </div>
  );
}
